import "../App.css";
import Cell from "./Cell";
import { format, add, sub, startOfWeek, endOfWeek, getWeek, isSunday, isSaturday } from "date-fns";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import cx from "classnames";
import moment from "moment";
import $ from "jquery";
import "parsleyjs";
import "jquery-confirm/dist/jquery-confirm.min";
import "jquery-confirm/dist/jquery-confirm.min.css";
import { endpoint } from "../config";

import { getUserInfo } from "../Auth";



const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const initialData = [
  {
    weekNo: 5,
    weekStart: "2023-01-23",
    weekEnd: "2023-01-29",
    submitted: 1,
    approved: 1,
    hours: [
      { date: "2023-01-23", hours: 8, approved: 8 },
      { date: "2023-01-24", hours: 8, approved: 8 },
      { date: "2023-01-25", hours: 8, approved: 5 },
      { date: "2023-01-26", hours: 8, approved: 6 },
      { date: "2023-01-27", hours: 8, approved: 8 },
      { date: "2023-01-28", hours: 0, approved: 0 },
      { date: "2023-01-29", hours: 0, approved: 0 },
    ],
  },
  {
    weekNo: 6,
    weekStart: "2023-12-30",
    weekEnd: "2023-02-05",
    submitted: 1,
    approved: 0,
    hours: [
      { date: "2023-01-30", hours: 8, approved: 0 },
      { date: "2023-01-31", hours: 8, approved: 0 },
      { date: "2023-02-01", hours: 8, approved: 0 },
      { date: "2023-02-02", hours: 8, approved: 0 },
      { date: "2023-02-03", hours: 8, approved: 0 },
      { date: "2023-02-04", hours: 0, approved: 0 },
      { date: "2023-02-05", hours: 0, approved: 0 },
    ],
  },
  {
    weekNo: 7,
    weekStart: "2023-02-06",
    weekEnd: "2023-02-12",
    submitted: 0,
    approved: 0,
    hours: [
      { date: "2023-02-06", hours: 8, approved: 0 },
      { date: "2023-02-07", hours: 8, approved: 0 },
      { date: "2023-02-08", hours: 8, approved: 0 },
      { date: "2023-02-09", hours: 8, approved: 0 },
      { date: "2023-02-10", hours: 8, approved: 0 },
      { date: "2023-02-11", hours: 0, approved: 0 },
      { date: "2023-02-12", hours: 0, approved: 0 },
    ],
  },
];

const Calendar = ({ value, onChange }) => {
  const [dates, setDates] = useState([]);
  const [submitted, setSubmitted] = useState(false); //Week Status submitted/open
  const [approved, setApproved] = useState(0); //Week Status Approved/Returned/Posted
  const [data, setData] = useState([]);
  const [hours, setHours] = useState([]);
  const [totalRows, setTotalRows] = useState();
  
  const [error, setError] = useState("");

  const [employee, setEmployee] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [weekendoff, setWeekendoff] = useState(false);
  const [billingStartDate, setBillingStartDate] = useState();
  const [billingEndDate, setBillingEndDate] = useState();
  const [maxSubmitHours, setMaxSubmitHours] = useState(0);


  const [submittedHours, setSubmittedHours] = useState({ submittedHours: 40, approvedHours: 24 });
  //const [weekendoff] = useState(weekendOff);
  //const weekendoff = weekendOff;

  const weekNo = getWeek(value, { weekStartsOn: 0 });
  const weekNoFormatted = format(value, "yyyy") + "-" + weekNo;
  const weekStart = startOfWeek(value, { weekStartsOn: 0 });
  const weekEnds = endOfWeek(value, { weekStartsOn: 0 });

  //const totalWeeks = differenceInWeeks(endOfYear(value), startOfYear(value));
  //const totalWeeks = getISOWeeksInYear(new Date(format(value, "yyyy"), 0, 2));
  const totalWeeks = moment().year(format(value, "yyyy")).weeksInYear();
  //console.log("week start", weekStart, "ends", weekEnds, new Date(format(value, "yyyy"), 0, 2), totalWeeks);

  const prevWeek = () => {
    onChange(sub(value, { weeks: 1 }));
  };
  const nextWeek = () => {
    onChange(add(value, { weeks: 1 }));
  };

  useEffect(() => {
    fetchEmployee();
  }, []);

  async function fetchEmployee() {
    const user = getUserInfo();

    const response = await axios.get(
      `${endpoint}/employee/${user.emailId}` 
    );
    const data = response.data;
    //console.log(data);
    if (data.status) {
      const emp = data.data;
      setEmployee(emp);
      setEmployeeId(emp.employeeId);
      setWeekendoff(emp.weekendOff);
      setMaxSubmitHours(emp.maxWeeklyHours);
      setBillingStartDate(emp.billingStartDate);
      setBillingEndDate(emp.billingEndDate);
      
      //console.log(emp);
    } else {
      toast("Please login with correct Employee Account.");
      console.log(data.message);
    }
  }


  useEffect(() => {
    async function getWeekData() {
      const response = await axios.get(`${endpoint}/week/${employeeId}/${weekNoFormatted}`);
      const data = response.data;
      //console.log(data);
      if (data.status) {
        const weekData = data.data;
        //toast("Hours Saved.");
        //console.log("Hour saved");
        //console.log(data.data);
        //if (data.data) {
        setData(data.data);
        

        if (weekData) {
          const hours = weekData.hours;
          const hoursS = hours.reduce((a, v) => (a = a + v.hours), 0);
          const hoursA = hours.reduce((a, v) => (a = a + v.approved), 0);
          //console.log(hours, hoursS, hoursA);
          setSubmittedHours({ submittedHours: hoursS, approvedHours: hoursA });
          //setSubmittedHours({ "submittedHours": hoursS, "approvedHours": hoursA });
          setHours(weekData.hours);
        }else{
          setHours([]);
        }
        //setDates();
        //setTimeout(getWeekDays, 500);
        //getWeekDays();
        //}
      } else {
        setData([]);
        setHours([]);
        console.log(data);
      }
    }
    employeeId && getWeekData();
  }, [weekNoFormatted, employeeId]);

  useEffect(() => {
    //data && setDates(getWeekDays(value));
    setError("");
  }, [value]);

  useEffect(() => {
    setSubmitted(false);
    /*
    data.forEach((row) => {
      if (row.weekNo === weekNo) {
        setSubmitted(row.submitted === 1);
        setApproved(row.approved === 1);
        setSubmittedHours({ submittedHours: 40, approvedHours: 24 });
      }
    });*/
    if (data) {
      setSubmitted(data.submitted === 1);
      setApproved(data.approved);
      //setSubmittedHours({ "submittedHours": data.submittedHours, "approvedHours": data.approvedHours });
    }
  }, [data, weekNo]);

  useEffect(() => {
    async function getWeekDays() {
      let final = [];
      //console.log('value', value);

      const weekstart = startOfWeek(value, { weekStartsOn: 0 });
      //console.log("week start on", weekstart);
      const weekData = data; //data.find((r) => r.weekNo === weekNo);
      const hoursData = weekData && weekData.hours;
      //console.log(weekData, hoursData);

      for (let i = 0; i < 7; i++) {
        const date = add(weekstart, { days: i });
        let hours, approvedHrs;

        const row = hoursData && hoursData.find((r) => r.date === format(date, "yyyy-MM-dd"));
        //console.log("hours", row);

        if (weekendoff && (isSunday(date) || isSaturday(date))) {
          hours = "";
          approvedHrs = "";
        } else {
          if (row) {
            //console.log(date, row, row.hours);
            hours = row.hours || "0";
            approvedHrs = row.approved || "0";
          } else {
            hours = "";
            approvedHrs = "";
          }
        }

        final.push({
          date: date,
          day: date.getDate(),
          formatted: format(date, "yyyy-MM-dd"),
          //projectId: row.projectId,
          //taskId: row.taskId,
          hours: hours,
          approved: approvedHrs,
        });
      }

      setDates(final);

      //return final;
    }
    getWeekDays();
  }, [value, weekendoff, data]);

  const hoursChanged = (date, projId, taskId, e) => {
    //console.log("changed", date, e.target.value);
    //const temp = [...dates];
    const temp = [...hours];
    //const changed = temp.find((a) => a.formatted === date);
    const changed = temp.find((a) => a.date === date && a.projectId===projId && a.taskId===taskId);
    if (e.target.value <= 8) {
      saveHours(date, projId, taskId, e.target.value || 0);
      //console.log(changed);
      if (changed){
        changed.hours = e.target.value;
      }else{
        //When hours not found then create new row
        temp.push({'weekId': 0, 'employeeId': employeeId, 'projectId': projId, 'taskId': taskId, 'date': date, 'hours': e.target.value, 'approved': 0});
      }
      
      //setDates(temp);
      setHours(temp);
    } else {
      saveHours(date, projId, taskId, 0);
    }
  };

  async function saveHours(date, projId, taskId, hours) {
    const params = new FormData();
    params.append("employeeId", employeeId);
    params.append("projectId", projId);
    params.append("taskId", taskId);
    params.append("weekNo", weekNoFormatted);
    params.append("date", date);
    params.append("hours", hours);
    params.append("weekStart", format(weekStart, "yyyy-MM-dd"));
    params.append("weekEnd", format(weekEnds, "yyyy-MM-dd"));
    const response = await axios.post(`${endpoint}/savehours`, params);
    const data = response.data;
    if (data.status) {
      //toast("Hours Saved.");
      //console.log("Hour saved");
    } else {
      console.error(data);
    }
  }
  const submit = async () => {
    let addform = $("#addForm");
    //addform.parsley();

    if (addform.parsley().isValid()) {
      //addform.parsley().reset();
      //console.log("valid");
      setError("");
    } else {
      //console.log("invalid");
      setError("All fields are mandatory, valid entries 0 to 8.");
      return false;
    }
    if (submittedHours.submittedHours > maxSubmitHours){
      setError(`Total submitted hours not be greater than ${maxSubmitHours}`);
      return false;
    }

    $.confirm({
      title: "Submit?",
      type: "orange",
      content: `Are you sure you want to Submit Hours?<br/><br/>After submit you won't be able to Change Hours.`,
      boxWidth: "400px",
      useBootstrap: false,
      buttons: {
        confirm: {
          text: "Submit",
          btnClass: "btn-primary",
          action: async () => {
            let params = new FormData();
            params.append("employeeId", employeeId);
            params.append("weekNo", weekNoFormatted);

            const response = await axios.post(`${endpoint}/week/submit`, params);
            const data = response.data;
            //console.log(data);
            if (data.status) {
              toast(`Week #${weekNo} has submitted successfully.`);
              //const emp = data.data;
              //setEmployee(emp);
              setApproved(0);
              setSubmitted(true);
            } else {
              //toast("Please login with correct Employee Account.");
              console.log(data.message);
            }
          },
        },
        cancel: () => {
          //$.alert('Request Cancelled');
        },
      },
    });
  };
  useEffect(()=>{
    updateTotals();

    function updateTotals() {
      if (hours) {
        var result = [];
        hours.reduce(function (res, value) {
          if (!res[value.date]) {
            res[value.date] = { date: value.date, hours: 0 };
            result.push(res[value.date]);
          }
          res[value.date].hours += parseFloat(value.hours || 0);
          return res;
        }, {});


        var result2 = [];
        //let hoursS = 0;
        dates.forEach((element) => {
          //console.log("date", element);
          let matched = result.find((r) => r.date === element.formatted);
          //hoursS += matched && parseFloat(matched.hours || 0);
          result2.push(matched && matched.hours);
        });
        
        const hoursS = hours.reduce((a, v) => (a = a + parseFloat(v.hours || 0)), 0);
        const hoursA = hours.reduce((a, v) => (a = a + parseFloat(v.approved || 0)), 0);
        setSubmittedHours({ submittedHours: hoursS, approvedHours: hoursA });
        //console.log(result, result2)
        setTotalRows(result2);
      }
    }

  }, [hours]);

  function getHours(projId, taskId, date){
    if (hours){
      let matched = hours.find((r) => r.date === format(date, "yyyy-MM-dd") && r.projectId === projId && r.taskId===taskId);
      //console.log("getHours", matched);
      return matched;
    }else{
      return [];
    }
  }
  function getTaskTotalHours(projId, taskId){
    if (hours){
      //console.log(hours);
      let matched = hours.filter((r) => r.projectId === projId && r.taskId===taskId);
      //console.log("matched", matched);
      if (matched){
        return matched && matched.reduce((a, v) => (a = a + parseFloat(v.hours || 0)), 0);
      }else{
        return 0;
      }
      
    }else{
      return 0;
    }    
  }

  

  return (
    <div className="calendar">
      <div className="header">
        <div className={"btn prev-week"} onClick={prevWeek}>
          {"<"}
        </div>
        <div className={"curr-month"}>
          {/*format(value, "MMMM yyyy")*/}
          {format(weekStart, "yyyy") === format(weekEnds, "yyyy") //If year is same
            ? format(weekStart, "MM") === format(weekEnds, "MM") //if month is same
              ? format(weekStart, "dd") + " - " + format(weekEnds, "dd MMMM yyyy")
              : //if month is different
                format(weekStart, "dd MMMM") + " - " + format(weekEnds, "dd MMMM yyyy")
            : //if year is difference
              format(weekStart, "dd MMMM yyyy") + " - " + format(weekEnds, "dd MMMM yyyy")}
        </div>
        <div className={"btn next-week"} onClick={nextWeek}>
          {">"}
        </div>
      </div>

      <form id="addForm">
        <div className="grid grid-cols-11">
          <Cell className={"head"}>Project</Cell>
          <Cell className={"head"}>Task</Cell>
          <Cell className={"head"}>Week</Cell>

          {daysOfWeek.map((day, index) => {
            return (
              <Cell className="head text-upper" key={index}>
                {day}
              </Cell>
            );
          })}
          <Cell className={"head"}>Total</Cell>

          {employee &&
            employee.assignedProjects &&
            employee.assignedProjects.map((project, projectIndex) => {
              return (
                <>
                  {
                    //If project has assigned multiple tasks
                    project.assignedTasks &&
                      project.assignedTasks.map((tasks, taskIndex) => {
                        return (
                          <>
                            <Cell key={project.projectId + tasks.taskId + taskIndex + 1} className={""}>
                              {project.project && project.project.projectName}
                            </Cell>
                            <Cell key={project.projectId + tasks.taskId + taskIndex + 2} className={""}>
                              <span title={tasks.task && tasks.task.description}>{tasks.task && tasks.task.taskName}</span>
                            </Cell>
                            <Cell key={project.projectId + tasks.taskId + taskIndex + 3} className={"flex-row2"}>
                              <div>
                                <span title="Current week">{weekNo}</span>
                                <span style={{}}>/</span>
                                <span title="Total weeks">{totalWeeks}</span>
                              </div>
                            </Cell>
                            {dates.map((row, index) => {
                              return (
                                <Cell
                                  key={project.projectId + tasks.taskId + taskIndex + 4 + index}
                                  className={"calendar-day"}
                                >
                                  {(!submitted || approved === 3) && ( //If not submitted then enter hours value
                                    <div className="calendar-input">
                                      <input
                                        type={"number"}
                                        min="0"
                                        max="8"
                                        className="form-control text-center"
                                        placeholder="hrs"
                                        disabled={
                                          (weekendoff && (isSunday(row.date) || isSaturday(row.date))) ||
                                          billingStartDate > row.formatted ||
                                          billingEndDate < row.formatted
                                        }
                                        data-parsley-excluded={
                                          (weekendoff && (isSunday(row.date) || isSaturday(row.date))) ||
                                          billingStartDate > row.formatted ||
                                          billingEndDate < row.formatted
                                        }
                                        value={
                                          getHours(project.projectId, tasks.taskId, row.date)
                                            ? getHours(project.projectId, tasks.taskId, row.date).hours
                                            : ""
                                        }
                                        onInput={(e) => hoursChanged(row.formatted, project.projectId, tasks.taskId, e)}
                                        title="Enter hours worked. 0 are also valid"
                                        required
                                        data-parsley-errors-container="#errorsContainer"
                                      ></input>
                                    </div>
                                  )}

                                  {submitted &&
                                    approved !== 3 && ( //If submitted then show submitted/approved hours
                                      <div className="calendar-submitted">
                                        {weekendoff && (isSunday(row.date) || isSaturday(row.date)) ? (
                                          <span className="inactive-date">X</span>
                                        ) : (
                                          <>
                                            {approved === 1 ? (
                                              <>
                                                {row.approved === row.hours ? (
                                                  <>
                                                    {getHours(project.projectId, tasks.taskId, row.date) && (
                                                      <>
                                                        <span
                                                          className="submited-hours approved"
                                                          title="Approved Hours"
                                                        >
                                                          {getHours(project.projectId, tasks.taskId, row.date).hours}
                                                        </span>
                                                        <span>&nbsp;hrs</span>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {getHours(project.projectId, tasks.taskId, row.date) && (
                                                      <>
                                                        <span className="approved" title="Approved Hours">
                                                          {getHours(project.projectId, tasks.taskId, row.date).approved}
                                                        </span>
                                                        &nbsp;
                                                        {"/"}&nbsp;
                                                        <span
                                                          className="submitted-hours text-danger"
                                                          title="Submitted Hours"
                                                        >
                                                          {getHours(project.projectId, tasks.taskId, row.date).hours}
                                                        </span>
                                                        &nbsp;{"hrs"}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <span className="submited-hours" title="Submitted Hours">
                                                  {getHours(project.projectId, tasks.taskId, row.date) &&
                                                    (getHours(project.projectId, tasks.taskId, row.date).hours ? getHours(project.projectId, tasks.taskId, row.date).hours + " hrs":'')}
                                                </span>
                                              </>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    )}
                                </Cell>
                              );
                            })}
                            <Cell className={"total fontweight-500"}>
                              {getTaskTotalHours(project.projectId, tasks.taskId)}
                            </Cell>
                          </>
                        );
                      })
                  }

                  {
                    //If project has no task assigned
                    !project.assignedTasks && (
                      <>
                        <Cell className={""}>{project.project && project.project.projectName}</Cell>
                        <Cell className={""}>NA</Cell>
                      </>
                    )
                  }
                </>
              );
            })}

          {
            //Total Row
          }
          <>
            <Cell className={"head grid-footer"}>TOTAL</Cell>
            <Cell className={"head grid-footer"}></Cell>
            <Cell className={"head grid-footer"}></Cell>
            {totalRows &&
              totalRows.map((element, index) => {
                return (
                  <Cell key={3546 + index} className={"head grid-footer calendar-day"}>
                    {element || 0}
                  </Cell>
                );
              })}
            <Cell className={"head grid-footer"}>{submittedHours.submittedHours}</Cell>
          </>
          </div>

          <div>
            <Cell className={"col-span-2"}>
              {approved === 3 && <div className="submitted-hours">Returned</div>}

              {approved === 2 && <div className="submitted-hours text-danger">Rejected</div>}

              {(!submitted || approved === 3) && (
                <button type="button" className="btn btn-primary" onClick={submit}>
                  Submit
                </button>
              )}

              {submitted && approved === 1 ? (
                <>
                  <div className="approved">Approved</div>
                </>
              ) : (
                submitted &&
                approved === 0 && (
                  <>
                    <div className="submitted-hours">Submitted</div>
                  </>
                )
              )}

              {submitted && approved === 1 && (
                <>
                  {submittedHours.submittedHours === submittedHours.approvedHours ? (
                    <>
                      <span className="approved" title="Approved Hours">
                        {submittedHours.approvedHours}&nbsp;{"hrs"}
                      </span>
                    </>
                  ) : (
                    <div className="calendar-submitted">
                      <span className="approved" title="Approved Hours">
                        {submittedHours.approvedHours}
                      </span>
                      &nbsp;
                      {"/"}&nbsp;
                      <span className="submitted-hours text-danger" title="Submitted Hours">
                        {submittedHours.submittedHours}
                      </span>
                      &nbsp;{"hrs"}
                    </div>
                  )}
                </>
              )}

              {submitted && approved === 2 && (
                <>
                  <span className="submitted-hours text-danger" title="Submitted Hours">
                    {submittedHours.submittedHours}&nbsp;{"hrs"}
                  </span>
                </>
              )}

              {submitted && approved === 0 && (
                <>
                  <span className="submitted-hours" title="Submitted Hours">
                    {submittedHours.submittedHours}&nbsp;{"hrs"}
                  </span>
                </>
              )}
            </Cell>
          </div>






















          {/*
          
          <Cell className={"week flex-row"}>
            <span style={{ marginTop: "-10px" }} title="Current week">
              {weekNo}
            </span>
            <span style={{}}>/</span>
            <span style={{ marginTop: "10px" }} title="Total weeks">
              {totalWeeks}
            </span>
          </Cell>
          

          {dates.map((row, index) => {
            return (
              <Cell key={index} className={""} value={row.date} hours={row.hours}>
                <div className="calendar-day">
                  <div
                    className={cx("calendar-date", row.formatted === format(new Date(), "yyyy-MM-dd") && "today")}
                    title={row.formatted === format(new Date(), "yyyy-MM-dd") ? "Today" : ""}
                  >
                    {row.day}
                  </div>
                  {(!submitted || approved === 3) && ( //If not submitted then enter hours value
                    <div className="calendar-input">
                      <input
                        type={"number"}
                        min="0"
                        max="8"
                        className="form-control text-center"
                        placeholder="hrs"
                        disabled={
                          (weekendoff && (isSunday(row.date) || isSaturday(row.date))) ||
                          billingStartDate > row.formatted ||
                          billingEndDate < row.formatted
                        }
                        data-parsley-excluded={
                          (weekendoff && (isSunday(row.date) || isSaturday(row.date))) ||
                          billingStartDate > row.formatted ||
                          billingEndDate < row.formatted
                        }
                        value={row.hours}
                        onChange={(e) => hoursChanged(row.formatted, e)}
                        title="Enter hours worked. 0 are also valid"
                        required
                        data-parsley-errors-container="#errorsContainer"
                      ></input>
                    </div>
                  )}
                  {submitted &&
                    approved !== 3 && ( //If submitted then show submitted/approved hours
                      <div className="calendar-submitted">
                        {weekendoff && (isSunday(row.date) || isSaturday(row.date)) ? (
                          <span className="inactive-date">X</span>
                        ) : (
                          <>
                            {approved === 1 ? (
                              <>
                                {row.approved === row.hours ? (
                                  <>
                                    <span className="submited-hours approved" title="Approved Hours">
                                      {row.hours}
                                    </span>
                                    &nbsp;{"hrs"}
                                  </>
                                ) : (
                                  <>
                                    <span className="approved" title="Approved Hours">
                                      {row.approved}
                                    </span>
                                    &nbsp;
                                    {"/"}&nbsp;
                                    <span className="submitted-hours text-danger" title="Submitted Hours">
                                      {row.hours}
                                    </span>
                                    &nbsp;{"hrs"}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <span className="submited-hours" title="Submitted Hours">
                                  {row.hours}
                                </span>
                                &nbsp;{"hrs"}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                </div>
              </Cell>
            );
          })}
          

          <Cell className={"col-span-2"}>
            {approved === 3 && <div className="submitted-hours">Returned</div>}

            {approved === 2 && <div className="submitted-hours text-danger">Rejected</div>}

            {(!submitted || approved === 3) && (
              <button type="button" className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            )}

            {submitted && approved === 1 ? (
              <>
                <div className="approved">Approved</div>
              </>
            ) : (
              submitted &&
              approved === 0 && (
                <>
                  <div className="submitted-hours">Submitted</div>
                </>
              )
            )}

            {submitted && approved === 1 && (
              <>
                {submittedHours.submittedHours === submittedHours.approvedHours ? (
                  <>
                    <span className="approved" title="Approved Hours">
                      {submittedHours.approvedHours}&nbsp;{"hrs"}
                    </span>
                  </>
                ) : (
                  <div className="calendar-submitted">
                    <span className="approved" title="Approved Hours">
                      {submittedHours.approvedHours}
                    </span>
                    &nbsp;
                    {"/"}&nbsp;
                    <span className="submitted-hours text-danger" title="Submitted Hours">
                      {submittedHours.submittedHours}
                    </span>
                    &nbsp;{"hrs"}
                  </div>
                )}
              </>
            )}

            {submitted && approved === 2 && (
              <>
                <span className="submitted-hours text-danger" title="Submitted Hours">
                  {submittedHours.submittedHours}&nbsp;{"hrs"}
                </span>
              </>
            )}

            {submitted && approved === 0 && (
              <>
                <span className="submitted-hours" title="Submitted Hours">
                  {submittedHours.submittedHours}&nbsp;{"hrs"}
                </span>
              </>
            )}
          </Cell>
          
        </div>
        */}

        <div className="errorsContainer pb-5">{error}</div>
      </form>
    </div>
  );
};

export default Calendar;
